import React, { useEffect } from 'react';
import { X, ExternalLink } from 'lucide-react';

/** Full-screen image preview for admin (profile / documents) */
export default function ImageViewer({
  open,
  src,
  alt = 'Preview',
  onClose,
}: {
  open: boolean;
  src: string;
  alt?: string;
  onClose: () => void;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open || !src) return null;

  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center bg-black/75 p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="absolute top-4 right-4 flex gap-2">
        <a
          href={src}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 rounded-lg bg-white/95 px-3 py-2 text-sm font-medium text-gray-800 hover:bg-white"
          onClick={(e) => e.stopPropagation()}
        >
          <ExternalLink size={14} /> Open
        </a>
        <button
          type="button"
          onClick={onClose}
          className="rounded-lg bg-white/95 p-2 text-gray-700 hover:bg-white"
          aria-label="Close"
        >
          <X size={18} />
        </button>
      </div>
      <img
        src={src}
        alt={alt}
        className="max-h-[88vh] max-w-[94vw] rounded-xl object-contain shadow-2xl bg-white"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
